import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../lib/api';
import BrandLogo from '../components/BrandLogo';

export default function Impressum() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get('/settings/public').then(r => setSettings(r.data || {})).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F9F7] text-[#1C1C19]" data-testid="impressum-page">
      <header className="border-b border-[#E5E5E0] bg-white">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/" className="block">
            <BrandLogo settings={settings} className="h-8" />
          </Link>
          <nav className="text-xs text-[#5C5C59] flex gap-4">
            <Link to="/" className="hover:text-[#1C1C19]" data-testid="imp-back-home">Reservierung</Link>
            <Link to="/datenschutz" className="hover:text-[#1C1C19]" data-testid="imp-datenschutz-link">Datenschutz</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="font-display text-3xl md:text-4xl mb-6">Impressum</h1>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Angaben gemäß § 5 TMG</h2>
          <p className="text-sm leading-relaxed">
            Gagliardi Gastronomie GmbH<br />
            Zwinglistraße 22<br />
            01277 Dresden<br />
            Deutschland
          </p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Betrieb</h2>
          <p className="text-sm leading-relaxed">
            La Contadina<br />
            Reisewitzer Straße 49<br />
            01159 Dresden
          </p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Vertreten durch</h2>
          <p className="text-sm leading-relaxed">Giuseppe Gagliardi</p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Kontakt</h2>
          <p className="text-sm leading-relaxed">
            {settings.restaurant_phone && <>Telefon: <a className="underline" href={`tel:${settings.restaurant_phone}`}>{settings.restaurant_phone}</a><br /></>}
            {settings.restaurant_email && <>E-Mail: <a className="underline" href={`mailto:${settings.restaurant_email}`}>{settings.restaurant_email}</a></>}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="font-display text-xl mb-2">Haftung für Inhalte</h2>
          <p className="text-sm leading-relaxed">
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
            forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </section>

        <div className="mt-12 pt-6 border-t border-[#E5E5E0] flex flex-wrap gap-4 text-xs text-[#5C5C59]">
          <Link to="/" data-testid="imp-footer-home" className="hover:text-[#1C1C19] underline">Zurück zur Reservierung</Link>
          <Link to="/datenschutz" data-testid="imp-footer-datenschutz" className="hover:text-[#1C1C19] underline">Datenschutz für Reservierungen</Link>
        </div>
      </main>
    </div>
  );
}
